
export default {
  state: {
    tenant: {},
    account: {},
    plans: {},
  },
  getters: {},
  actions: {
    createNewTenantWithNewUser({}, data) {
      const { firstName, lastName, email, password, phoneNumber, companyName } = data

      const payload = { firstName, lastName, email, password, phoneNumber, companyName }

      return this.$api.post('/public/tenant/new', payload)
    },
    async fetchPublicProducts({}, {}) {

      console.log('fetching')
      const products = this.$api.get('/public/tenant/products')
        .catch(e => console.log(e))


      return products
    }
  },
  mutations: {}
}
